import { h } from 'preact'
import { t } from '../../libs/translationsUtils/translations'

interface Props {
  totalPageCount: string,
  currentPage: string
}

const generateNewUrl = (newPage: number) => {
  const regex = /\/index\d+\.html/
  const splittedUrl = window.location.pathname.replace(regex, '')
  const newPagination = newPage === 1 ? '' : `/index${newPage}.html`
  return `${window.location.origin}${splittedUrl}${newPagination}${window.location.hash}${window.location.search}`
}

const PAGE_WIDTH:number = 3

const Pagination = ({ totalPageCount, currentPage }: Props) => {
  const page:number = parseInt(currentPage)
  const pageCount: number = parseInt(totalPageCount)

  const prevLink = generateNewUrl(page - 1)
  const nextLink = generateNewUrl(page + 1)
  const pages = Array.from(Array(totalPageCount), (_, i) => i + 1)

  const items = []

  for (const i of pages) {
    if (i === 1 || i === page || (i >= page - pageCount && i <= page + PAGE_WIDTH) || i === pageCount) {
      const newItem = (
        <li className={`page ${i === page ? 'current' : ''}`}>
          <a href={generateNewUrl(i)} className='qa-pagination-link'>
            { i }
          </a>
        </li>
      )
      items.push(newItem)
    } else {
      if (i === 2 && i < page - PAGE_WIDTH) {
        items.push(<li className='gap'><span>...</span></li>)
      }
      if (i === pageCount - 1 && i > page + PAGE_WIDTH) {
        items.push(<li className='gap'><span>...</span></li>)
      }
    }
  }

  return (
    <div className='pagination-wrapper'>
      <div className='pagination is-hidden-mobile-only '>
        <ul className='pages'>
          {
            page > 1 ? (
              <li className='pagination-icon-container qa-pagination-prev pagination-prev'>
                <a className='prev' href={prevLink}>
                  <i className='icon--previous-page' />
                </a>
              </li>
            ) : null
          }
          { items }
          {
            page < pageCount ? (
              <li className='pagination-icon-container qa-pagination-prev pagination-prev'>
                <a className='next' href={nextLink}>
                  <i className='icon--next-page' />
                </a>
              </li>
            ) : null
          }
        </ul>
      </div>
      <div className='pagination is-hidden-mobile-up'>
        <div className='pages'>
          {
            page > 1 ? (
              <div className='pagination-icon-container pagination-first'>
                <a className='first qa-pagination-first' href={generateNewUrl(1)}>
                  <i className='icon--first-page' aria-hidden='true' />
                </a>
              </div>
            ) : null
          }
          {
            page > 1 ? (
              <div class='pagination-icon-container pagination-prev'>
                <a class='prev qa-pagination-prev' href={generateNewUrl(page - 1)}>
                  <i class='icon--previous-page' aria-hidden='true' />
                </a>
              </div>
            ) : null
          }
          <span class='paginatin-current'>
            { t('Forum', 'pagination.label') } { page } / { pageCount }
          </span>
          {
            page < pageCount ? (
              <div class='pagination-icon-container pagination-next'>
                <a class='next qa-pagination-next' href={nextLink}>
                  <i class='icon--next-page' aria-hidden='true' />
                </a>
              </div>
            ) : null
          }
          {
            page < pageCount ? (
              <div class='pagination-icon-container pagination-last'>
                <a class='last qa-pagination-last' href={generateNewUrl(pageCount)}>
                  <i class='icon--last-page' aria-hidden='true' />
                </a>
              </div>
            ) : null
          }
        </div>
      </div>
    </div>
  )
}

export default Pagination
